import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { Footer } from 'components/Footer'
import { Hero } from './components/Hero'
import { EssentialNutrients } from './components/EssentialNutrients'
import { BetterThanCooked } from './components/BetterThanCooked'
import { SafeFood } from './components/SafeFood'
import { HealthiestFood } from './components/HealthiestFood'
import { Delivery } from './components/Delivery'
import { RawFoodBenefits } from './components/RawFoodBenefits'
import { Reviews } from './components/Reviews'
import { PremadeMeals } from './components/PremadeMeals'
import { WhyWeFeedRawRoot, Claim } from './WhyWeFeedRaw.styles'

type WhyWeFeedRawOwnProps = ComponentProps<typeof WhyWeFeedRawRoot>
export type WhyWeFeedRawProps = WhyWeFeedRawOwnProps & {}

export const WhyWeFeedRaw = (_props: WhyWeFeedRawProps) => {
  const { t } = useTranslation()

  const header = <Header />

  return (
    <WhyWeFeedRawRoot>
      <Layout header={header}>
        <Stack direction="column" gap={{ '@initial': '7', '@bp2': '11' }} alignItems="center">
          <Hero />
          <EssentialNutrients />
          <Stack
            direction="column"
            gap="0"
            css={{ width: '100%', backgroundColor: '$accent-account-submenu' }}
            alignItems="center"
          >
            <Claim>
              <Text
                size={{ '@initial': 'h4', '@bp2': 'h3' }}
                as="h3"
                weight="bold"
                color="primary-800"
                align="center"
              >
                {t('why-we-feed-raw:claim')}
              </Text>
            </Claim>
            <RawFoodBenefits />
            <Delivery />
            <HealthiestFood />
            <Reviews />
          </Stack>
          <BetterThanCooked />
          <SafeFood />
          <Stack direction="column" gap="0" css={{ width: '100%' }}>
            <PremadeMeals />
            <Footer />
          </Stack>
        </Stack>
      </Layout>
    </WhyWeFeedRawRoot>
  )
}

WhyWeFeedRaw.displayName = 'WhyWeFeedRaw'
